import React, {useState, useEffect} from 'react';
import { Switch, Route, Link, useLocation } from 'react-router-dom';
import LogoutButton from './logout-button';
import MuseumPost from './Museum/admin-museum'
import ExhibitionPost from './Exhibition/admin-exhibition';
import EventPost from './Event/admin-event';
import MuseumEditList from './Museum/edit-museum-list-page';
import ExhibitionEditList from './Exhibition/edit-exhibition-list-page';
import EventEditList from './Event/edit-event-list-page';
import MuseumEditDetail from './Museum/edit-museum-detail-page';
import ExhibitionEditDetail from './Exhibition/edit-exhibition-detail-page';
import EventEditDetail from './Event/edit-event-detail-page';
import ExhibitionEdit from './Exhibition/edit-exhibition';
import MuseumEdit from './Museum/edit-museum';
import EventEdit from './Event/edit-event'

const PrivatePage = () => {

    let url = useLocation();
    let tag = url.pathname.split('/')[3]
    
    const [postButton, setPostButton]=useState(false)
    const [editButton, setEditButton]=useState(false)
    const [buttonPostMuseum, setButtonPostMuseum]=useState(false)
    const [buttonPostExhibition, setButtonPostExhibition]=useState(false)
    const [buttonPostEvent, setButtonPostEvent]=useState(false)
    const [buttonEditMuseum, setButtonEditMuseum]=useState(false)
    const [buttonEditExhibition, setButtonEditExhibition]=useState(false)
    const [buttonEditEvent, setButtonEditEvent]=useState(false)

    const postMuseumButtonChange = ()=>{
        setPostButton(true);
        setEditButton(false);
        setButtonPostMuseum(true);
        setButtonPostExhibition(false);
        setButtonPostEvent(false);
        setButtonEditMuseum(false);
        setButtonEditExhibition(false);
        setButtonEditEvent(false);
    }
    const postExhibitionButtonChange = ()=>{
        setPostButton(true);
        setEditButton(false);
        setButtonPostMuseum(false);
        setButtonPostExhibition(true);
        setButtonPostEvent(false);
        setButtonEditMuseum(false);
        setButtonEditExhibition(false);
        setButtonEditEvent(false);
    }

    const postEventButtonChange = ()=>{
        setPostButton(true);
        setEditButton(false);
        setButtonPostMuseum(false);
        setButtonPostExhibition(false);
        setButtonPostEvent(true);
        setButtonEditMuseum(false);
        setButtonEditExhibition(false);
        setButtonEditEvent(false);
    }

    const editMuseumButtonChange = ()=>{
        setPostButton(false);
        setEditButton(true);
        setButtonPostMuseum(false);
        setButtonPostExhibition(false);
        setButtonPostEvent(false);
        setButtonEditMuseum(true);
        setButtonEditExhibition(false);
        setButtonEditEvent(false);
    }

    const editExhibitionButtonChange = ()=>{
        setPostButton(false);
        setEditButton(true);
        setButtonPostMuseum(false);
        setButtonPostExhibition(false);
        setButtonPostEvent(false);
        setButtonEditMuseum(false);
        setButtonEditExhibition(true);
        setButtonEditEvent(false);
    }

    const editEventButtonChange = ()=>{
        setPostButton(false);
        setEditButton(true);
        setButtonPostMuseum(false);
        setButtonPostExhibition(false);
        setButtonPostEvent(false);
        setButtonEditMuseum(false);
        setButtonEditExhibition(false);
        setButtonEditEvent(true);
    }

    return (
        <div>
            <div className='edit-flex'>

            <div className='edit-left'>
            

            <h2>Edit and Post Page</h2>
            <LogoutButton/>
            
            <div id='post_edit_button_flex'>
            <div id='post_wrapper'>
            <p>POST</p>
            <div className='admin_button_flex'>
            <Link to='/admin/private/museum' ><p onClick={ postMuseumButtonChange } className={`tag_admin ${buttonPostMuseum? "highlight_tag_admin" :"normal_tag_admin"}`}>Museum</p></Link>
            <Link to='/admin/private/exhibition' ><p onClick={ postExhibitionButtonChange } className={`tag_admin ${buttonPostExhibition? "highlight_tag_admin" :"normal_tag_admin"}`}>Exhibition</p></Link>
            <Link to='/admin/private/event'><p onClick={ postEventButtonChange } className={`tag_admin ${buttonPostEvent? "highlight_tag_admin" :"normal_tag_admin"}`}>Event</p></Link>
            </div>
            </div>

            <div id='edit_wrapper'>
            <p>EDIT</p>
            <div className='admin_button_flex'>
            <Link to='/admin/private/museum-list' ><p onClick={ editMuseumButtonChange } className={`tag_admin ${buttonEditMuseum? "highlight_tag_admin" :"normal_tag_admin"}`}>Museum</p></Link>
            <Link to='/admin/private/exhibition-list'><p onClick={ editExhibitionButtonChange } className={`tag_admin ${buttonEditExhibition? "highlight_tag_admin" :"normal_tag_admin"}`}>Exhibition</p></Link>
            <Link to='/admin/private/event-list'><p onClick={ editEventButtonChange } className={`tag_admin ${buttonEditEvent? "highlight_tag_admin" :"normal_tag_admin"}`}>Event</p></Link>
            </div>
            </div>
            </div>

            <Switch>
            <Route path='/admin/private/museum'><MuseumPost/></Route>
            <Route path='/admin/private/exhibition'><ExhibitionPost/></Route>
            <Route path='/admin/private/event'><EventPost/></Route>
            <Route path='/admin/private/museum-list'><MuseumEditList/></Route>
            <Route path='/admin/private/exhibition-list'><ExhibitionEditList/></Route>
            <Route path='/admin/private/event-list'><EventEditList/></Route>
            </Switch>
            </div>


            <div className='edit-right'>
            <Route path='/admin/private/museum-list/detail/:id'><MuseumEditDetail/></Route>
            <Route path='/admin/private/exhibition-list/detail/:id'><ExhibitionEditDetail/></Route>
            <Route path='/admin/private/event-list/detail/:id'><EventEditDetail/></Route>
            <Route path='/admin/private/exhibition-list/edit/:id'><ExhibitionEdit/></Route>  
            <Route path='/admin/private/museum-list/edit/:id'><MuseumEdit/></Route>
            <Route path='/admin/private/event-list/edit/:id'><EventEdit/></Route>
            </div>
            </div>
        </div>
    );
};

export default PrivatePage;